<!-- 热量表列表 -->
<template>
    <div>
        <el-table
            ref="multipleTable"
            :data="tableData_RLB"
            tooltip-effect="dark">
            <!-- <el-table-column
                prop="householdname"
                label="业主名称">
            </el-table-column>
            <el-table-column
                prop="housename"
                label="房间号">
            </el-table-column> -->
            <el-table-column
                prop="deviceType"
                label="表计类型">
            </el-table-column>
            <el-table-column
                prop="deviceModel"
                label="表计型号">
            </el-table-column>
            <el-table-column
                prop="deviceSerial"
                label="序列号"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="status"
                label="在线状态"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success': 'danger'">{{fmtOnlineStatus(scope.row)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="_status"
                label="运行状态"
                :formatter="funFmtRlbOnlineStatus"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="coolingCapacity"
                label="累计冷量"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="heatingCapacity"
                label="累计热量">
            </el-table-column>
            <el-table-column
                prop="power"
                label="功率">
            </el-table-column>
            <el-table-column
                prop="instantDischarge"
                label="瞬时流量">
            </el-table-column>
            <el-table-column
                prop="discharge"
                label="累计流量">
            </el-table-column>
            <el-table-column
                prop="inTemperature"
                label="供水温度">
            </el-table-column>
            <el-table-column
                prop="cycleTemperature"
                label="回水温度">
            </el-table-column>
            <el-table-column
                prop="uptime"
                label="运行时间">
            </el-table-column>
            <el-table-column
                prop="date"
                label="当前日期">
            </el-table-column>
			<el-table-column label="操作" width="180" fixed="right">
			    <!-- 在线才能操作 -->
			    <template slot-scope="scope">
			        <el-button type="text"  @click="handleAddClick(scope.row)">查看表计历史数据</el-button>
			    </template>
			</el-table-column>
        </el-table>
    </div>
</template>

<script>
import { funFmtOnlineStatus, funFmtRlbOnlineStatus } from '@/utils/utils'
export default {
    name:  'CmpRlbTable',
    props: ['tableData_RLB'],
    data() {
        return {
        };
    },
    methods: {
		handleAddClick(row){
			this.$router.push("/historyreport/" + row.terminalid)
		},
        // 格式化在线状态
        fmtOnlineStatus(row) {
            return funFmtOnlineStatus(row.status);
        },
        funFmtRlbOnlineStatus(row) {
            return funFmtRlbOnlineStatus(row._status);
        },
    },
}

</script>